import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  wrapperInfrastructureType: {
    display: 'flex',
    gap: '12px',
    flexDirection: 'column',
    '&.loop-video-wrapper': {
      borderRadius: '8px',
      backgroundColor: 'black',
      '& video': {
        borderRadius: '8px',
      },
    },
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
    },
  },
  wrapperImage: {
    width: '100%',
    marginRight: '10px',
    [theme.breakpoints.down('md')]: {
      marginRight: '0px',
      marginBottom: '10px',
    },
  },
  fullScreenImage: {
    background: 'white',
    position: 'absolute',
    bottom: '0px',
    right: '0px',
    display: 'flex',
    color: theme.palette.primary.main,
  },
  linkNewWindow: {
    position: 'relative',
    '& > img': {
      maxWidth: '160px',
      minWidth: '160px',
    },
  },
  textTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  textBody: {
    fontSize: '14px',
    lineHeight: '24px',
    whiteSpace: 'pre-wrap',
  },
  link: {
    textDecoration: 'underline',
  },
  withoutBody: {
    marginRight: '0px',
    '& img': {
      maxWidth: 'none',
      minWidth: 'none',
      width: '100%',
    },
  },
  zoomButton: {
    borderRadius: '0px',
    position: 'absolute',
    top: '0px',
    right: '0px',
    background: '#ffffff99',
    minWidth: 'auto',
    width: '48px',
    height: '48px',
    '&:hover': {
      background: 'white',
    },
  },
  zoomButtonIframe: {
    position: 'absolute',
    bottom: '20px',
    right: '20px',
    background: '#f4f6f9',
    minWidth: 'auto',
    width: '44px',
    height: '44px',
    '&:hover': {
      background: 'white',
    },
  },
  zoomButtonIframeMobile: {
    position: 'initial',
    width: '44px',
    minWidth: '44px',
    height: '44px',
  },
  headerIframeMobile: {
    position: 'absolute',
    padding: '16px 16px 0 16px',
    width: '100%',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    zIndex: '1',
  },
  headerIframeMobileTitle: {
    fontFamily: 'inherit',
    color: 'white',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '24px',
  },
  zoomStyle: {
    width: '30px',
    height: '30px',
  },
  appPanoramaWrapper: {
    width: '100%',
    height: '100%',
    '& .image-gallery-content.fullscreen': {
      height: '100vh',
      top: 'unset',
      transform: 'none',
      '& .image-gallery-slide-wrapper': {
        height: '100%',
        '& .image-gallery-slides': {
          height: '100%',
          '& .image-gallery-slide': {
            height: '100%',
          },
        },
      },
    },
  },
}));
